import { render, staticRenderFns } from "./DestinationList.vue?vue&type=template&id=663127fe"
import script from "./DestinationList.vue?vue&type=script&lang=js"
export * from "./DestinationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports